import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import ConfirmationDialog from 'components/ConfirmationDialog';

// Utils
import { isProduction } from '@src/utils';

// Icons
import crossReset from './Icon/cross-reset.svg';

import {
  Container,
  Description,
  HighlightedText,
  ResetButton,
  SvgIcon,
} from './StyledComponents';

const DialogMessage = () => (
  <Box flexDirection="column" padding="zero">
    <Text>
      Do you wish to "Reset" your channel to Sync with Web-SDK? Please note that
      all manual edits on this channel will be lost.
    </Text>
  </Box>
);

function UnSyncInfo({ onReset, channelName, isAutoPreview }) {
  const [showDialog, setShowDialog] = useState(false);
  const isResetDisabled = isProduction();
  return (
    <>
      <ConfirmationDialog
        active={showDialog}
        title="Do you want to reset your channel?"
        successCallback={onReset}
        cancelCallback={() => setShowDialog(false)}
        okTitle="Reset"
        cancelTitle="Cancel"
        message={<DialogMessage />}
        okActionType="danger"
      />
      <Container data-testid="UnSyncInfo">
        <Box padding="zero">
          <SvgIcon src={crossReset} size="big" />
        </Box>
        <Box padding="zero" flexDirection="column">
          <Description variant="body.md">
            Since&nbsp;
            <HighlightedText variant="h4.bold">{channelName}</HighlightedText>
            &nbsp; bot responses now contain manual edits, they will no longer
            be auto-synced with your &nbsp;
            <HighlightedText variant="h4.bold">Web SDK</HighlightedText>
            &nbsp;responses.
          </Description>
          {isAutoPreview && (
            <Description variant="body.md" style={{ marginTop: '12px' }}>
              *Auto-preview-generation is not supported on this channel yet.
            </Description>
          )}
        </Box>
        <Box padding="zero" alignItems="flex-start">
          <ResetButton
            onClick={isResetDisabled ? null : () => setShowDialog(true)}
            disabled={isResetDisabled}
          >
            Reset
          </ResetButton>
        </Box>
      </Container>
    </>
  );
}

UnSyncInfo.propTypes = {
  onReset: PropTypes.func,
  channelName: PropTypes.string,
  isAutoPreview: PropTypes.bool,
};

UnSyncInfo.defaultProps = {
  onReset: () => {
    /* */
  },
  channelName: '',
  isAutoPreview: false,
};

export default React.memo(UnSyncInfo);
